
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vs-outsourcing",
      function () {
        return require("private-next-pages/vs-outsourcing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vs-outsourcing"])
      });
    }
  